import type { Fields } from '../types'
import { getFieldKeysForPreset } from './getFieldKeysForPreset'

export const createRepeaterNavMenuFieldMap = ({
  fields,
  pageLinkFieldKey,
}: {
  fields: Fields
  pageLinkFieldKey: string
}) => {
  const { titleFieldKey } = getFieldKeysForPreset(fields)
  return {
    title_fld: titleFieldKey,
    'link-categories-title_fld': pageLinkFieldKey,
  }
}

export const createCategoryRouterFieldMap = ({
  fields,
}: {
  fields: Fields
}) => {
  const { titleFieldKey, imageFieldKey, altTextFieldKey, descriptionFieldKey } =
    getFieldKeysForPreset(fields)
  return {
    description_fld: descriptionFieldKey,
    title_fld: titleFieldKey,
    image_fld: imageFieldKey,
    imagealttext_fld: altTextFieldKey,
  }
}

export const createCategoryItemFieldMap = ({ fields }: { fields: Fields }) => {
  const { titleFieldKey, imageFieldKey, altTextFieldKey, descriptionFieldKey } =
    getFieldKeysForPreset(fields)

  return {
    title_fld: titleFieldKey,
    description_fld: descriptionFieldKey,
    image_fld: imageFieldKey,
    imagealttext_fld: altTextFieldKey,
  }
}
